import React from 'react';
import { LabelField, ImageField } from '../../components/Admin';

export default class Study extends React.Component {
	render(){
		var { website, onChangeProp, onChangeImage } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.studyTitle} onChange={onChangeProp} prop="studyTitle" name="Título" info="40 caracteres" />
				<LabelField defaultValue={website.study} onChange={onChangeProp} prop="study" name="Descripción" info="1014 caracteres" rows={8} />
				<LabelField defaultValue={website.studyText1} onChange={onChangeProp} prop="studyText1" name="Texto 1" info="40 caracteres" rows={1} />
				<LabelField defaultValue={website.studyText2} onChange={onChangeProp} prop="studyText2" name="Texto 2" info="110 caracteres" rows={3} />
				<ImageField defaultValue={website.studyImage} onChange={onChangeImage} prop="studyImageId" name="Imagen" />
			</div>
		)
	}
}
